import { createAuthClient } from "better-auth/react";
import { genericOAuthClient } from "better-auth/client/plugins";
import { encryptPassword } from "./login-crypto";

// 拦截登录/注册请求，将请求体中的明文密码替换为 RSA 密文，避免开发者工具/抓包读取明文。
const AUTH_PASSWORD_PATHS = ["/sign-in/email", "/sign-up/email"];

const encryptingFetch: typeof fetch = async (input, init) => {
    try {
        const url =
            typeof input === "string" ? input : input instanceof URL ? input.href : input.url;
        const body = init?.body;
        if (
            url &&
            typeof body === "string" &&
            AUTH_PASSWORD_PATHS.some((p) => url.includes(p))
        ) {
            const parsed = JSON.parse(body);
            if (parsed && typeof parsed.password === "string") {
                parsed.password = await encryptPassword(parsed.password);
                return fetch(input, { ...init, body: JSON.stringify(parsed) });
            }
        }
    } catch {
        // 解析失败则原样发送
    }
    return fetch(input, init);
};

// Auto-switch baseURL based on environment (keep aligned with `lib/auth.ts` getBaseURL)
const getBaseUrl = () => {
    if (typeof window !== 'undefined') {
        return window.location.origin;
    }
    const explicit =
        process.env.BETTER_AUTH_URL?.trim() || process.env.NEXT_PUBLIC_API_URL?.trim();
    if (explicit) {
        return explicit.replace(/\/$/, "");
    }
    const port = process.env.PORT || "3000";
    return `http://localhost:${port}`;
};

export const authClient = createAuthClient({
    baseURL: getBaseUrl(),
    plugins: [genericOAuthClient()],
    fetchOptions: {
        customFetchImpl: encryptingFetch,
    },
});
